<div class="data-table-container">
  <div *ngIf="loading" class="loading-overlay">
    <mat-progress-spinner diameter="40" mode="indeterminate"></mat-progress-spinner>
  </div>
  
  <table mat-table [dataSource]="dataSource" matSort class="data-table">
    <ng-container *ngFor="let column of columns" [matColumnDef]="column.key">
      <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="!column.sortable">
        {{ getColumnLabel(column.key) }}
      </th>
      <td mat-cell *matCellDef="let row">
        {{ row[column.key] }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="onRowClick(row)" class="table-row"></tr>
  </table>

  <mat-paginator
    *ngIf="showPagination"
    [pageSizeOptions]="pageSizeOptions"
    [pageSize]="pageSize"
    showFirstLastButtons>
  </mat-paginator>
</div>

